import { ref, type Ref } from "vue";

/**
 * 仮会員QRコード画面のURL生成
 * 環境変数 VITE_SELF_REGISTRATION_SERVICE_URL と storeId から仮会員登録URLを組み立てる。
 * 純粋な文字列ロジックでありDOM操作は行わない。
 *
 * URL生成→QR描画の連携（resolveAndRenderUrl）は index.vue 側で
 * generateAndSetUrl + renderAllQrs を組み合わせて構成する。
 *
 * @param deps.currentInternalId - m_shop.internal_id（URLのstoreIdパラメータに使用）
 *
 * @returns registerUrl - 生成された仮会員登録URL
 * @returns generateAndSetUrl - URLを生成して registerUrl に設定する
 * @returns clearUrl - registerUrl を空にリセットする
 */
export const useTmpMemberQrCodeUrl = (deps: {
  currentInternalId: Ref<string>;
}) => {
  const registerUrl = ref("");

  /**
   * URLを生成して registerUrl に設定する
   * VITE_SELF_REGISTRATION_SERVICE_URL + storeId パラメータからURL組み立て
   * @throws internal_id が未取得の場合にエラー
   */
  const generateAndSetUrl = (): void => {
    const internalId = deps.currentInternalId.value;
    if (!internalId) {
      throw new Error("internal_id を取得できませんでした。");
    }
    const base = import.meta.env.VITE_SELF_REGISTRATION_SERVICE_URL;
    registerUrl.value = `${base}?storeId=${encodeURIComponent(internalId)}`;
  };

  /**
   * registerUrl を空にリセットする
   * 店舗セレクタクリア時などに使用
   */
  const clearUrl = (): void => {
    registerUrl.value = "";
  };

  return {
    registerUrl,
    generateAndSetUrl,
    clearUrl,
  };
};
